
<app-chip class="me-2"
  [valorAnterior]="proposta?.negociacao?.valorOfertaAnterior"
  [informacoes]="proposta?.status"
  [statusNegociacao]="proposta?.negociacao?.statusNegociacao"
  [badgeTotal]="true">
</app-chip>

<div *ngIf="proposta?.valorCliente">
  <div class="row align-items-center mt-2">
    <div class="col">
      <div class="desktop_body_P1"> {{proposta?.valorCliente | currency: 'BRL' ?? '-'}} </div>
      <div class="desktop_body_P7 color-cinza-do-gelo" *ngIf="proposta?.valorComissao">
        / Comissão <span class="color-sucesso"> {{proposta?.valorComissao | currency: 'BRL' ?? '-'}} </span>
      </div>
    </div>
    <div class="col-auto" *ngIf="proposta?.negociacao">
      <button (click)="clickBotaoDetalhesNegociacao()" class="btn btn-outline-secondary btn-sm">
        <span class="desktop_body_P7">
          Detalhes
          <img src="assets/imgs/icones/info-azul.svg" class="ms-2" alt="">
        </span>
      </button>
    </div>
  </div>

  <div>
    <span class="desktop_body_P4 color-primario" *ngIf="podeVerMensagemVencimento()" >
      Vencimento <b> {{ retornarTextoVencimento() }} </b>
    </span>
    <p class="color-azul-caneta mt-2">
      Os valores apresentados nesta fase são meramente estimativos, podendo sofrer alteração após a análise detalhada do
      processo.
    </p>
  </div>
</div>

<div class="mt-3" *ngIf="podeVerMensagemFeedback()">
  <app-alerta-de-feedback [mensagem]="retornarMensagemDeFeedback()"></app-alerta-de-feedback>
</div>

<div class="mt-3 mb-3">
  <div class="row">
    <div class="col-6">
      <button *ngIf="podeVerBotaoNegociarProposta()" (click)="clickBotaoNegociar()" data-bs-dismiss="offcanvas" class="btn btn-sm btn-outline-secondary w-100">
        Negociar
        <img src="assets/imgs/icones/coin.svg" class="ms-2" alt="">
      </button>
    </div>
    <div class="col-6">
      <a [ngClass]="{'disabled': !proposta?.urlDocumentoProposta}" [href]="proposta?.urlDocumentoProposta" target="_blank" class="btn btn-sm btn-outline-secondary w-100">
        <span class="text-black">Baixar proposta </span>
        <img src="assets/imgs/icones/download.svg" class="ms-2" alt="">
      </a>
    </div>
    <div class="col-12 mt-3" *ngIf="podeVerBotaoAceitardProposta()">
      <button (click)="clickBotaoAceitar()" data-bs-dismiss="offcanvas" class="btn btn-sm btn-primary w-100">
        Aceitar
        <img src="assets/imgs/icones/check.svg" class="ms-2">
      </button>
    </div>
    <div class="col-12 mt-3" *ngIf="podeVerBotaoNovoCalculo()">
      <button (click)="clickBotaoSolicitarNovoCalculo()" data-bs-dismiss="offcanvas" class="btn btn-sm btn-primary w-100" id="btnNovoCalculoMobile" >
        <span>Solicitar novo cálculo</span>
        <img src="assets/imgs/icones/check.svg" class="ms-2">
      </button>
    </div>
  </div>
</div>

<div class="mt-3">
  <div class="row border-bottom border-top py-2 g-1">
    <div class="col-auto"> <img src="assets/imgs/icones/martelinho.svg" alt=""> </div>
    <div class="col-auto"> N° Precatório </div>
    <div class="col text-end"> {{proposta?.numeroPrecatorio ?? '-'}} </div>
  </div>
  <div class="row border-bottom py-2 g-1">
    <div class="col-auto"> <img src="assets/imgs/icones/coin.svg" alt=""> </div>
    <div class="col-auto"> Valor de face </div>
    <div class="col text-end"> {{proposta?.valorBruto | currency: 'BRL' ?? '-'}} </div>
  </div>
  <div class="row border-bottom py-2 g-1">
    <div class="col-auto"> <img src="assets/imgs/icones/paper-pen.svg" alt=""> </div>
    <div class="col-auto"> Honorários </div>
    <div class="col text-end"> {{proposta?.honorarios? proposta?.honorarios + '%': '-'}}</div>
  </div>
</div>

<div class="mt-3">
  <p class="desktop_body_P11 text-uppercase"> Informações </p>
  <div class="row py-2 g-1">
    <div class="col-auto text-muted"> Cedente </div>
    <div class="col text-end"> {{proposta?.nomeCliente ?? '-'}} </div>
  </div>
  <div class="row py-2 g-1">
    <div class="col-auto text-muted"> CPF </div>
    <div class="col text-end"> {{proposta?.cpf ? (proposta?.cpf | mask : utilsHelper.formatarCpfCnpj(proposta?.cpf)) : '-'}} </div>
  </div>
  <div class="row py-2 g-1">
    <div class="col-auto text-muted"> Responsável </div>
    <div class="col text-end text-capitalize"> {{proposta?.nomeUsuarioParceiro ?? '-'}} </div>
  </div>
  <div class="row py-2 g-1">
    <div class="col-auto text-muted"> Entrada </div>
    <div class="col text-end"> {{proposta?.dataCriacao | date:'dd/MM/yyyy' ?? '-'}} </div>
  </div>
</div>

<div class="float-end" *ngIf="exibirBotaoCancelarProposta()">
  <button class="btn" (click)="clickBotaoCancelar()" data-bs-dismiss="offcanvas"><img src="assets/imgs/icones/trash.svg" alt=""></button>
</div>
<div class="w-100" *ngIf="podeVerBotaoEnviarDocumento()">
  <button class="btn btn-sm btn-outline-secondary w-100"
    (click)="irParaEnviarDocumentos(proposta.propostaId, proposta.nomeCliente, proposta.cpf, proposta.motivoReprovacaoDocumento, proposta.status)">
    Anexar documentos
    <img class="ms-2" src="assets/imgs/icones/upload.svg" alt="">
  </button>
</div>
